import SmallDelete from '@/components/atom/icon/SmallDelete';
import { DIRECT_SEARCH_KEYWORD_TYPE } from '@/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult';
import theme from '@/styles/theme';
import { QnaSearchKeywordList } from '@/types/qna';
import React from 'react';
import styled from 'styled-components';

export interface RecentKeyWordProps {
  recentKeywordViewData: QnaSearchKeywordList;
  onSearchDirectKeyword: (key: string, type: DIRECT_SEARCH_KEYWORD_TYPE) => void;
  onDeleteItemRecentKeyword: (keyword: string) => void;
  onDeleteAllRecentKeyword: () => void;
}

const RecentKeyWord = ({
  recentKeywordViewData,
  onSearchDirectKeyword,
  onDeleteItemRecentKeyword,
  onDeleteAllRecentKeyword,
}: RecentKeyWordProps) => {
  return (
    <>
      {!!recentKeywordViewData.length && (
        <Wrapper>
          <RecentKeywordTopList>
            <RecentKeywordTitle>최근 검색어</RecentKeywordTitle>
            <RecentKeywordAllRemove onClick={onDeleteAllRecentKeyword}>전체 삭제</RecentKeywordAllRemove>
          </RecentKeywordTopList>
          <RecentKeywordItemList>
            {recentKeywordViewData.map((keyword) => (
              <RecentKeywordItem key={keyword}>
                <div
                  role='presentation'
                  onClick={() => onSearchDirectKeyword(keyword, DIRECT_SEARCH_KEYWORD_TYPE.RECENT)}
                >
                  {keyword}
                </div>
                <button type='button' onClick={() => onDeleteItemRecentKeyword(keyword)}>
                  <SmallDelete color={theme.color.gray600} size={16} />
                </button>
              </RecentKeywordItem>
            ))}
          </RecentKeywordItemList>
        </Wrapper>
      )}
    </>
  );
};
export default RecentKeyWord;

export const Wrapper = styled.div`
  padding-bottom: 16px;
  border-bottom: 8px solid ${({ theme }) => theme.color.gray30};
`;

export const RecentKeywordTopList = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RecentKeywordTitle = styled.span`
  padding: 24px;
  align-items: center;
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray600};
`;

export const RecentKeywordAllRemove = styled.button`
  padding: 24px;
  align-items: center;
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray400};
`;

export const RecentKeywordItemList = styled.div`
  display: flex;
  padding: 0 24px 16px;
  flex-wrap: wrap;
  gap: 8px;

  > * {
    margin-right: 0;
  }
`;

export const RecentKeywordItem = styled.div`
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray600};
  display: inline-flex;
  align-items: center;
  justify-contents: center;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.gray100};
  border-radius: 40px;
  padding: 8px 15px;
  height: 38px;

  & > div {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.color.gray700};
  }

  & > button {
    border: none;
    z-index: 2;
    padding: 0;
    margin-left: 4px;
  }
`;
